import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Alert, Button } from 'react-bootstrap';
import GameCard from './GameCard';
import GameInstructions from './GameInstructions';
import { generateGameCards } from '../data/words';

const GameBoard = () => {
  const [cards, setCards] = useState([]);
  const [selectedCards, setSelectedCards] = useState([]);
  const [matchedPairs, setMatchedPairs] = useState([]);
  const [score, setScore] = useState(0);
  const [level, setLevel] = useState(1);
  const [showSuccess, setShowSuccess] = useState(false);
  const [moves, setMoves] = useState(0);
  const [gameStartTime, setGameStartTime] = useState(null);
  const [gameTime, setGameTime] = useState(0);

  useEffect(() => {
    initializeGame();
  }, [level]);

  useEffect(() => {
    let interval;
    if (gameStartTime && !showSuccess) {
      interval = setInterval(() => {
        setGameTime(Math.floor((Date.now() - gameStartTime) / 1000));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [gameStartTime, showSuccess]);

  const initializeGame = () => {
    const newCards = generateGameCards(level);
    setCards(newCards);
    setSelectedCards([]);
    setMatchedPairs([]);
    setScore(0);
    setMoves(0);
    setShowSuccess(false);
    setGameStartTime(Date.now());
  };

  const handleCardClick = (card) => {
    if (selectedCards.length >= 2) return;
    if (selectedCards.find(c => c.id === card.id)) return;
    if (matchedPairs.includes(card.pairId)) return;

    const newSelectedCards = [...selectedCards, card];
    setSelectedCards(newSelectedCards);
    setMoves(moves + 1);

    if (newSelectedCards.length === 2) {
      checkForMatch(newSelectedCards);
    }
  };

  const checkForMatch = (selected) => {
    const [first, second] = selected;
    
    setTimeout(() => {
      if (first.pairId === second.pairId && first.type !== second.type) {
        // 匹配成功
        setMatchedPairs([...matchedPairs, first.pairId]);
        setScore(score + 10 * level);
        
        // 检查是否完成所有配对
        if (matchedPairs.length + 1 === cards.length / 2) {
          setShowSuccess(true);
        }
      }
      
      setSelectedCards([]);
    }, 1000);
  };

  const nextLevel = () => {
    setLevel(level + 1);
  };

  const resetGame = () => {
    setLevel(1);
    initializeGame();
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Container className="game-board">
      <GameInstructions />
      <div className="game-header text-center mb-4">
        <h1>单词消消乐</h1>
        <div className="game-info">
          <Row className="justify-content-center">
            <Col md={2}>
              <div className="info-box">
                <strong>关卡</strong>
                <div>{level}</div>
              </div>
            </Col>
            <Col md={2}>
              <div className="info-box">
                <strong>分数</strong>
                <div>{score}</div>
              </div>
            </Col>
            <Col md={2}>
              <div className="info-box">
                <strong>步数</strong>
                <div>{moves}</div>
              </div>
            </Col>
            <Col md={2}>
              <div className="info-box">
                <strong>时间</strong>
                <div>{formatTime(gameTime)}</div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {showSuccess && (
        <Alert variant="success" className="text-center">
          <h4>恭喜通关！</h4>
          <p>你用了 {moves} 步，耗时 {formatTime(gameTime)}</p>
          <Button variant="primary" onClick={nextLevel}>
            下一关
          </Button>
          <Button variant="secondary" className="ms-2" onClick={resetGame}>
            重新开始
          </Button>
        </Alert>
      )}

      <div className="game-grid">
        <Row className="justify-content-center">
          {cards.map((card) => (
            <Col key={card.id} xs="auto">
              <GameCard
                card={card}
                onCardClick={handleCardClick}
                isSelected={selectedCards.find(c => c.id === card.id)}
                isMatched={matchedPairs.includes(card.pairId)}
              />
            </Col>
          ))}
        </Row>
      </div>

      <div className="text-center mt-4">
        <Button variant="outline-primary" onClick={initializeGame}>
          重新开始本关
        </Button>
        <Button variant="outline-secondary" className="ms-2" onClick={resetGame}>
          返回第一关
        </Button>
      </div>
    </Container>
  );
};

export default GameBoard;